import {
  Flex,
  Table,
  TableCaption,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { VARIANT, WHITE } from "../../../../constants/colors";
import { simplifiedExtract } from "../../../../interfaces/defaultInterfaces";
import moment from "moment";
import {
  CaptionFormater,
  ToLocaleFormat,
} from "../../../../defaultFunctions/formaters";

export default function TableReleaseContract({ data, title }: any) {
  const [salesCredit, setSalesCredit] = useState(Array<simplifiedExtract>);
  useEffect(() => {
    setSalesCredit(data);
  }, [data]);

  return (
    <>
      {salesCredit.length && (
        <Flex w={"100%"} flexDirection={"column"} mt={4}>
          <Text m={4} fontSize={"16px"} fontWeight={"bold"}>
            {title}
          </Text>
          <Table variant={"striped"}>
            <TableCaption fontWeight={"bold"}>
              Total:{" "}
              {ToLocaleFormat(salesCredit.reduce((acc, i) => acc + i.valor, 0))}
            </TableCaption>
            <Thead>
              <Tr>
                <Th bgColor={VARIANT} color={WHITE}>
                  Data
                </Th>
                <Th bgColor={VARIANT} color={WHITE}>
                  Tipo
                </Th>
                <Th bgColor={VARIANT} color={WHITE}>
                  Observação
                </Th>
                <Th bgColor={VARIANT} color={WHITE}>
                  Valor do Lançamento
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {salesCredit &&
                salesCredit.map((item, index) => {
                  return (
                    <Tr key={index}>
                      <Td>
                        {moment(item?.dataLancamento).format(
                          "DD/MM/YYYY HH:mm"
                        )}
                      </Td>
                      <Td>{item?.tipoLancamento?.lancamento}</Td>
                      <Td>{CaptionFormater(item?.contrato?.obs)}</Td>
                      <Td>
                        {item?.valor.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </Td>
                    </Tr>
                  );
                })}
            </Tbody>
          </Table>
        </Flex>
      )}
    </>
  );
}
